<script src="https://static.airtable.com/js/embed/embed_snippet_v1.js"></script>

<iframe class="airtable-embed airtable-dynamic-height" [src]="iframeUrl | safe" frameborder="0" onmousewheel="" width="100%" height="3079" style="background: transparent; border: 1px solid #ccc;"></iframe>
